module.exports = __webpack_public_path__ + "static/img/wallet.af2fb083.png";